export default function Footer() {
  return (
    <footer className="relative bg-dark-800/60 backdrop-blur-xl border-t border-neon-blue/20 py-12 md:py-16">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12">
          {/* Brand */}
          <div className="space-y-4">
            <h3 className="text-2xl md:text-3xl font-black bg-gradient-to-r from-neon-blue to-neon-purple bg-clip-text text-transparent">
              Freedom Experience
            </h3>
            <p className="text-gray-400 text-sm md:text-base">
              Preparando jovens para o futuro com as habilidades que realmente importam.
            </p>
          </div>

          {/* Redes Sociais */}
          <div>
            <h4 className="text-white font-bold text-base md:text-lg mb-4">Redes Sociais</h4>
            <div className="flex gap-4">
              <a 
                href="https://www.instagram.com/freedomschool_brasil" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-neon-blue/20 to-neon-purple/20 rounded-full hover:from-neon-blue/40 hover:to-neon-purple/40 transition-all duration-300 cursor-pointer group"
              >
                <i className="ri-instagram-fill text-2xl text-neon-blue group-hover:scale-110 transition-transform duration-300"></i>
              </a>
              <a 
                href="https://www.youtube.com/@FreedomSchoolOficial" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-neon-blue/20 to-neon-purple/20 rounded-full hover:from-neon-blue/40 hover:to-neon-purple/40 transition-all duration-300 cursor-pointer group"
              >
                <i className="ri-youtube-fill text-2xl text-neon-blue group-hover:scale-110 transition-transform duration-300"></i>
              </a>
            </div>
          </div>

          {/* Contato */}
          <div>
            <h4 className="text-white font-bold text-base md:text-lg mb-4">Contato</h4>
            <ul className="space-y-2 md:space-y-3">
              <li className="flex items-center gap-2 text-gray-400 text-sm md:text-base">
                <i className="ri-mail-fill text-neon-blue"></i>
                <a href="mailto:z@zulk.com.br" className="hover:text-neon-blue transition-colors duration-300">
                  z@zulk.com.br
                </a>
              </li>
              <li className="flex items-center gap-2 text-gray-400 text-sm md:text-base">
                <i className="ri-time-fill text-neon-blue"></i>
                <span>Seg - Sex: 9h às 18h</span>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-bold text-base md:text-lg mb-4">Legal</h4>
            <ul className="space-y-2 md:space-y-3">
              <li>
                <a href="/termos" className="text-gray-400 hover:text-neon-blue transition-colors duration-300 cursor-pointer text-sm md:text-base">
                  Termos de Uso
                </a>
              </li>
              <li>
                <a href="/privacidade" className="text-gray-400 hover:text-neon-blue transition-colors duration-300 cursor-pointer text-sm md:text-base">
                  Política de Privacidade
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-6 md:pt-8 border-t border-neon-blue/10">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-400 text-xs md:text-sm text-center md:text-left">
              © 2024 Freedom Experience. Todos os direitos reservados.
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-neon-blue transition-colors duration-300 text-xs md:text-sm cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}